import Vue from "vue";

/**
 * Class Payment Service
 */
export default class PaymentService extends Vue {
  private customActions = {};
  private resource: any = this.$resource(
    "lead/payment-option/{platformId}{/id}",
    {},
    this.customActions
  );

  // GET all
  public index() {
    let platformId = this.$auth.user().id_platform;
    return this.resource.get({ platformId }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET one
  public show(id: number) {
    let platformId = this.$auth.user().id_platform;
    return this.resource.get({ platformId, id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // POST
  public store(data: any) {
    let platformId = this.$auth.user().id_platform;
    return this.resource.save({ platformId }, data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // PUT
  public update(id: number, data: any) {
    let platformId = this.$auth.user().id_platform;
    return this.resource.update({ platformId, id }, data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // DELETE
  public delete(id: number) {
    let platformId = this.$auth.user().id_platform;
    return this.resource.delete({ platformId, id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }
}
